import {
  trigger,
  transition,
  style,
  query,
  animateChild,
  animate,
  group,
  animation,
} from '@angular/animations';

export const fadeAnimation = trigger('routeAnimations', [
  transition('* <=> *', [
    query(':enter, :leave', [
      style({
        opacity: 0,
      }),
    ]),
    query(':enter', [
      animate(
        '1000ms ease',
        style({
          opacity: 1,
        }),
      ),
    ]),
  ]),
]);
